import { FONT } from '$gstyles';
import { Snackbar } from '@material-ui/core';
import styled from 'styled-components';

export const SnackbarWrapper = styled(Snackbar)`
  .MuiAlert-message {
    font-size: ${FONT.MEDIUM};
  }
  .MuiSvgIcon-root.MuiSvgIcon-fontSizeSmall {
    font-size: ${FONT.LARGE};
  }
`;
